import { Panel } from "@/components/AppShell";
import { shortDate } from "@/lib/format";

const COLS = ["min", "pts", "reb", "ast", "fg3m", "pra", "fgm", "stl", "blk", "tov", "plus_minus"];
const LABEL = { min: "MIN", pts: "PTS", reb: "REB", ast: "AST", fg3m: "3PM", pra: "PRA", fgm: "FG", stl: "STL", blk: "BLK", tov: "TO", plus_minus: "+/-" };

function cell(r, c) {
  if (c === "fgm") return `${r.fgm}-${r.fga}`;
  if (c === "min") return Math.round(r.min);
  if (c === "plus_minus") return r.plus_minus > 0 ? `+${r.plus_minus}` : r.plus_minus;
  return r[c];
}

export function GameLog({ rows }) {
  return (
    <Panel data-testid="game-log">
      <h2 className="font-display text-2xl font-bold uppercase p-5 pb-3">Last 10 games</h2>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-900/90 text-slate-400 text-xs uppercase tracking-wider">
            <tr>
              <th className="px-4 py-2.5 text-left">Date</th>
              <th className="px-4 py-2.5 text-left">Opp</th>
              {COLS.map((c) => <th key={c} className="px-3 py-2.5 text-right">{LABEL[c]}</th>)}
              <th className="px-4 py-2.5 text-right">Source</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.game_id} data-testid={`log-row-${r.game_id}`} className="border-t border-slate-800/70 hover:bg-slate-800/40">
                <td className="px-4 py-2.5 font-mono-num text-slate-300">{shortDate(r.game_day)}</td>
                <td className="px-4 py-2.5 font-semibold">{r.home ? "vs" : "@"} {r.opp}</td>
                {COLS.map((c) => <td key={c} className={`px-3 py-2.5 text-right font-mono-num ${["pts", "pra"].includes(c) ? "text-slate-50 font-bold" : "text-slate-300"}`}>{cell(r, c)}</td>)}
                <td className="px-4 py-2.5 text-right">
                  <span className={`text-[11px] px-2 py-0.5 rounded border font-mono-num ${r.source === "api" ? "text-blue-300 border-blue-500/30 bg-blue-950/40" : "text-amber-300 border-amber-500/30 bg-amber-950/40"}`}>
                    {r.source === "api" ? "ESPN" : "screenshot"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!rows.length && <p className="p-5 text-slate-500">No games stored.</p>}
      </div>
    </Panel>
  );
}
